import LTR from "@brand-icons/global/social-instagram/social-instagram-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialInstagramIcon = iconFactory("SocialInstagramIcon", LTR);
